import { render, staticRenderFns } from "./SaleDetails.vue?vue&type=template&id=41608aee&scoped=true"
import script from "./SaleDetails.vue?vue&type=script&lang=js"
export * from "./SaleDetails.vue?vue&type=script&lang=js"
import style0 from "./SaleDetails.vue?vue&type=style&index=0&id=41608aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41608aee",
  null
  
)

export default component.exports